export default "__VITE_ASSET__35652a82__"